document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[id^="BundleAddToCart-"]').forEach((button) => {
    button.addEventListener('click', handleBundleAdd);
  });
});

async function handleBundleAdd(event) {
  const button = event.currentTarget;
  const sectionId = button.id.replace('BundleAddToCart-', '');
  const statusEl = document.getElementById(`BundleAddToCartStatus-${sectionId}`);
  const wrap = document.getElementById(`bundle-faq-${sectionId}`);

  const variantIds = Array.from(
    wrap.querySelectorAll('[data-bundle-variant-id]')
  )
    .map((el) => el.getAttribute('data-bundle-variant-id'))
    .filter(Boolean);

  if (!variantIds.length) {
    setStatus(statusEl, 'This bundle has no available products.', 'error');
    return;
  }

  const items = variantIds.map((id) => ({ id: parseInt(id, 10), quantity: 1 }));

  button.disabled = true;
  setStatus(statusEl, 'Adding to cart…', '');

try {
  const response = await fetch(
    `${window.Shopify?.routes?.root || '/'}cart/add.js`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items }),
    }
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      errorData.description || 'Could not add bundle to cart.'
    );
  }

  setStatus(
    statusEl,
    'Added to your cart. Redirecting in just seconds...',
    'success'
  );

  document.dispatchEvent(
    new CustomEvent('cart:refresh', { bubbles: true })
  );

  if (
    typeof window.Shopify !== 'undefined' &&
    document.querySelector('cart-drawer')
  ) {
    document
      .querySelector('cart-drawer')
      .dispatchEvent(new CustomEvent('cart:build'));
  }

  // Redirect to cart after 5 seconds
  setTimeout(() => {
    window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
  }, 5000);

} catch (error) {
  setStatus(
    statusEl,
    error.message || 'Something went wrong. Please try again.',
    'error'
  );
} finally {
  button.disabled = false;
}
}

function setStatus(el, message, state) {
  if (!el) return;
  el.textContent = message;
  if (state) {
    el.setAttribute('data-state', state);
  } else {
    el.removeAttribute('data-state');
  }
}
